// extracted by mini-css-extract-plugin
export default {"modal-content__inner":"SwapBoxModal_modal-content__inner__7zvzW","test":"SwapBoxModal_test__D4PGl"};